import React from 'react';
import { ChevronRightSVG } from '../../@common_components/svgs/chevron-right.svg';

const ChevronRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return <ChevronRightSVG {...props} />;
};

export { ChevronRightIcon };
